import React, { useEffect, useState } from 'react'
import { useForm, useFormState } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { withOidcSecure } from '@axa-fr/react-oidc'
import { width } from "../../CustomComponents/Card/CardStyles";
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import { useTranslation } from 'react-i18next';
import HomeLayout from '../../Layout/HomeLayout';
import DynamicCard from '../../CustomComponents/DynamicHomeCard';
import { useNavigate } from 'react-router';
import { SecuritySidebar, uniqueNonces } from '../../../utils';
import CustomInput from '../../CustomComponents/FormInputs';
import { autoFocusFunction, generateRegexExpression, generateRegexExpression1, retrieveData } from '../../../helpers/utils/Utils';
import * as yup from 'yup';
import { EMAIL_OTP_GENERATION, STATUS_SUCCESS_CODE, META_DATA_POLICIES, CHANGE_PASSWORD, ISDEV_ENV } from '../../../network//URLConstants';
import { fetchConfigarationData } from '../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';
import { GetApiHeadersWithOutBearer, GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import PasswordReset from '../../../assets/images/activate_change_lock.png';
import { displayErrorMessage } from '../../../utils';
import { useKeyDown } from '../../../hooks/useKeyDown';
import Loader from "../../CustomComponents/Loader";
import LeftBar from '../../CustomComponents/DynamicComponent/LeftBar';


// const appConfigData = await fetchConfigarationData();

// console.log(appConfigData,"appConfigData from password")

// alert(JSON.stringify(appConfigData))


const ChangePasswordPopup = () => {
    const { t } = useTranslation();
    const userId = useSelector(state => state.userId);
    const appConfigData = useSelector(state => state.appConfigData);
    const navigate = useNavigate();
    const [policyCriteria, setPolicyCriteria] = useState({});
    const [isShowPolicyRules, setIsShowPolicyRules] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [policyRules, setPolicyRules] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [isOldPasswordValid, setIsOldPasswordValid] = useState(false)
    const [isNewPasswordValid, setIsNewPasswordValid] = useState(false)
    const [isRepeatPasswordValid, setIsRepeatPasswordValid] = useState(false)
    const regexpression = generateRegexExpression(policyCriteria?.PolicyTemplate);
    const { watch } = useForm();


    const sessionKey = useSelector(state => state.loggedSessionKey);

    ///password change modal
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px]  font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title font-normal cursor-pointer pointer-events-none lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] text-black ";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none leading-[30px]";
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [modelImage, setModelImage] = useState('')
    const [showModel, setShowModel] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassWord] = useState('');

    const [changePasswordFinalUrl,setChangePasswordFinalUrl] = useState("")

    const accessTokenToApi = useSelector(state => state.accessToken);


    const showAlertModal = (showModel, highlightMsg, headerMsg,
        subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text,
        btn1TypeAcpt, modelImage) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }


    const closeCustomAlertModal = () => {
        setShowModel(false);
    }

    const onAcptBtnClick = async () => {
        setShowModel(false)
        navigate('/Security')

    }
    const onCancelBtnClick = () => {
        setShowModel(false)

    }


    ///Form
    const schema = yup.object().shape({
        currentPassword: yup.string()
            .required("Current password is required"),
        newPassword: yup.string()
            .required("New password is required")
            .matches(
                regexpression, "The password you entered does not meet the requirements as listed below."
            )
            .notOneOf([yup.ref('oldPassword'), null], "New password must be different from the current password"),
        repeatPassword: yup.string()
            .required("Confirm new password is required")
            .oneOf([yup.ref('newPassword'), null],  t("repeat_password_error_msg")),
    });


    const {
        register,
        handleSubmit,
        formState: { errors }, control, clearErrors,
        getValues,
        setFocus,
        setError
    } = useForm({
        mode: 'onTouched',
        resolver: yupResolver(schema),
        // defaultValues: { newPassword: "newPassword@12" }
    });

    //ON CHANGE VALIDATION
    const [isMinMax, setIsMinMax] = useState(false);
    const [isNumeric, setIsNumeric] = useState(false);
    const [isAlpha, setIsAlpha] = useState(false);
    const [isLowerCase, setIsLowerCase] = useState(false);
    const [isUpperCase, setIsUpperCase] = useState(false);
    const [isSpecialChar, setIsSpecialChar] = useState(false);
    const [isNewPassword, setIsNewPassword] = useState(false);

    const handleOldPasswordChange = (e) => {
        if (e.target.value != "") {
            clearErrors()
        }


        setErrorMessage('');
        const oldPassword = e.target.value;
        if(newPassword){
            if (newPassword != oldPassword) {
                setIsNewPassword(true);
            } else {
                setIsNewPassword(false);
            }

        }
        setOldPassword(oldPassword);
        setIsOldPasswordValid(true)
    }

    const fieldArray = ["password", "newPassword", "repeatPassword"]
    autoFocusFunction(fieldArray, getValues, setFocus);

    useEffect(() => {
        getPasswordPolicy();
    }, [userId])

    const getPasswordPolicy = async () => {
        try {
            setIsLoading(true);
            const applicationId = appConfigData.APP_CLIENT_ID;
            const url = `${META_DATA_POLICIES}language=en&applicationid=${applicationId}&avn=1.0.0&isNew=false`;
            const deviceId = await retrieveData('updatedDeviceId')
            const headers = await GetApiHeadersWithOutBearer(deviceId);

            const response = await GetRequest(url, headers);
            const responseObj = JSON.parse(response);
            if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
                setIsLoading(false);
                const policyObj = responseObj.Response?.PasswordPolicy;
                setPolicyCriteria(policyObj);
                setPolicyRules(policyObj.PolicyRules);
                setIsShowPolicyRules(true)
                setErrorMessage('');
                clearErrors();
            } else {
                setIsLoading(false);
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                // setErrorMessage(displayText);
                setError("repeatPassword", {
                    type: "manual",
                    message: displayText,
                  })

            }

        } catch (error) {
            setIsLoading(false);
        }
    }


    const handleChangePasswordClick = () => {
          getChangePasswordScreen()
        // if (twoFactAuthenticationDone) {
        //     navigate('/Security/ChangePassword');
        // } else {
        //     // alert("change password need to do")
        //     generate2FAOtp(t('change_password'))
        // }
    };

    const getChangePasswordScreen = async () => {
        debugger;
        const nounce = await uniqueNonces();
        const url = `${appConfigData.CHANGE_PASSWORD_POPUP_URL}authorize?p=B2C_1A_CHANGEPASSWORD&client_id=${appConfigData.CLIENT_ID}&nonce=${nounce}&redirect_uri=${appConfigData.REDIRECT_URI_FOR_PASSWORD_SCREEN}&scope=openid&response_type=id_token`;
        const width = 600;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + 50; 
        const popupWindow = window.open(
            url,
            'ChangePasswordPopup',
            `width=${width},height=${height},scrollbars=yes,resizable=yes,left=${left},top=${top}`
        );
        const timer = setInterval(() => {
            try {
                if (popupWindow.location.href !== url && popupWindow.location.href !== 'about:blank') {
                    clearInterval(timer);
    
                        window.location.href = popupWindow.location.href;
                        popupWindow.close();
                        handleUrl()
                }
            } catch (e) {
                // Ignore cross-origin errors
            }
    
            if (popupWindow.closed) {
                handleUrl()
                clearInterval(timer);
            }
        }, 1000); 
    };
    
    const handleUrl = () => {
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        if (hashParams.has('error') && hashParams.get('error') === 'access_denied') {
            navigate('/Security/ChangePassword')
        } else if (hashParams.has('id_token')) {
            showAlertModal(true, t('Success!'), t('Your new password has been set.'), '', true, false, t('Back to Security'), '', true, PasswordReset);
        }
    };

    useEffect(() =>{
        getChangePasswordScreen() 
    },[])

    return (
        <>1

            <HomeLayout>

                <SecuritySidebar changePasswordClicked={handleChangePasswordClick} selectedIndex={1} />

                <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
                      animate__animated animate__fadeInRight '>
                    <DynamicCard
                        header={false}
                        CardRadius={true}
                        cardWidth={width.allpolicies}
                        HeaderRadius={true}
                        backgroundColor={'pink'}
                        isWhite={true}
                        HeaderContent={false}>

                        <div class="lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500] 
                      lg:text-[26px] md:text-[22px] 
                      sm:text-[20px] text-[20px] leading-[36px] font-hanken-grotesk 
                        sm:mx-0 mx-4">{t("change_password")}</div>
                        <div className='border-t-[2.5px] border-[#A3CEBB] pb-10 
                        sm:mx-0 mx-4'></div>

                        <div className='sm:w-full w-[264px] sm:mx-0 mx-4'>
                            <div className='font-serif-pro 
                        lg:text-[32px] md:text-[26px] sm:text-[16px] text-[25px] 
                         md:leading-[38px] sm:leading-[24px] leading-[31px] 
                         font-normal text-[#2965FB]'>
                                <p>{t("let’s_lock")}</p>
                                <p className='text-black'>{t("Set_new_password_for_popup")}</p>
                            </div>
                        </div>

                        <form >
                            <div className='w-full flex justify-center lg:py-16 md:py-14 sm:pt-10 sm:pb-0 py-4'>
                                <div className='sm:w-[62%] w-full sm:mx-0 mx-4'>
                                    <div className='lg:w-[384px] md:w-[340px] sm:w-[224px]'>
                                        <div className='md:w-[282px] sm:w-[198px] flex flex-col gap-4 mt-4'>
                                          
                                        </div>
                                        {/* {Object.keys(errors).length > 0 && (
                                            <div className='mb-2'>
                                                {displayErrorMessage(errors[Object.keys(errors)[0]].message)}
                                            </div>
                                        )}
                                        {errorMessage && (
                                            <div className='mb-2'>
                                                {displayErrorMessage(errorMessage)}
                                            </div>
                                        )} */}
                                       
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className='flex flex-col pb-16'>
                            <div className='flex flex-row sm:justify-end justify-between sm:mx-0 mr-[6%] ml-[4%]'>
                                {/* <button onClick={() => { navigate('/Security') }} className='font-hanken-grotesk 
                                leading-[18px] text-[#2965FB] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                 font-bold'>{t("back")}</button>

                                {(!oldPassword || !newPassword || !repeatPassword) && <button tabIndex={0} className='font-hanken-grotesklg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px]
                                leading-[18px] text-[#94C3E8]
                                 font-bold ml-14'>{t("save")}</button>}

                                {(oldPassword && newPassword && repeatPassword) && <button tabIndex={0} className='font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                leading-[18px] text-[#2965FB]
                                 font-bold ml-14' onClick={() => {
                                        handleSubmit(onSubmit)();
                                    }}>{t("save")}</button>} */}

                            </div>
                        </div>
                        {/* <div className='pb-16 text-[18px] text-[#2965FB] font-hanken-grotesk
                        font-medium leading-[28px] cursor-pointer'>{t("Cancel")}</div> */}

                    </DynamicCard>
                </div>
            </HomeLayout>

            <CustomAlertModel isOpen={showModel} isBorderNone={true}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
                // highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                // HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
            />
            {isLoading && <Loader />}

        </>
    )
}

export default withOidcSecure(ChangePasswordPopup)